import type { InventoryLevel } from '../interfaces/ILogistics.js';

/**
 * What is estimated to be on site NOW: the last count drawn down at its daily
 * rate (`dailyRate × daysLeft`, one decimal), and zero once the count has run
 * out (`needsCheck`). One rule for the Sync dialog's seed, the merge-on-arrival
 * seed and the Scheduler's stock check — which used to compare a task against
 * the raw last count, calling 180 m "in stock" out of 520 m counted three weeks
 * earlier and burnt down to ~150 m since (QA 2026-10-18).
 */
export function estimatedOnHand(level: IOnHandSource): number {
  if (level.needsCheck) return 0;
  // Never more than was counted: the rate is the display rate (one decimal),
  // so rate × days can overshoot a small count — 5 over 14 days shows 0.4/day.
  return Math.min(level.amount, Math.round(level.dailyRate * level.daysLeft * 10) / 10);
}

/** What `estimatedOnHand` reads off a level — a full `InventoryLevel`, or the
 *  order form's `IOpenStock` pick of it. */
export type IOnHandSource = Pick<InventoryLevel, 'amount' | 'dailyRate' | 'daysLeft'> & { needsCheck?: boolean };
